module.exports = __webpack_public_path__ + "static/media/ibshungry.230ad73a.webp";